// PlayerPortal.jsx
import { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PlayerContext } from '../context/PlayerContext.js';

let createPortal = () => null;

export const PlayerPortal = ({ children = null, container = null }) => {
  const { player } = useContext(PlayerContext);
  const [createPortalLoaded, setCreatePortalLoaded] = useState(false);

  useEffect(() => {
    const loadCreatePortal = async () => {
      const { createPortal: loadedCreatePortal } = await import(
        '../partial/react-dom/createPortal.js'
      );
      if (loadedCreatePortal) {
        createPortal = loadedCreatePortal;
        setCreatePortalLoaded(true);
      }
    };
    loadCreatePortal();
  }, []);

  if (player && container && createPortalLoaded) {
    return createPortal(children, container);
  }

  return null;
};

PlayerPortal.propTypes = {
  children: PropTypes.node,
  container: PropTypes.object,
};

export default PlayerPortal;
